import { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';

import { InfoModal, WithTooltip } from 'basic-components';
import { Preview as PreviewIcon } from 'basic-components/icons';
import { DataScienceEnums } from 'dashboard-services/api/dataScience';
import Query from 'dashboard-services/api/Query';

import { commonDatalakeActions } from 'actions/modules/datalake';
import getApiConfig from 'api/ApiConfig';
import { filesDatalakeQueries } from 'queries/modules/datalake';

import { When } from 'react-if';

const Preview = ({ value, onChange, valueType = undefined, dynamic = false, name = undefined, output = false, provider: providerProp = undefined }) => {
  const dispatch = useDispatch(),
        [open, setOpen] = useState(false),
        selectedNodeId = useSelector(state => state.datascienceState.creatorState.builderState.doubleClickedTask),
        statuses = useSelector(state => state.datascienceState.creatorState.basicState.statuses),
        date = useMemo(() => {
          const current = statuses?.find(status => status?.payload?.nodeId === selectedNodeId)
          if(current) {
            return current.startTime;
          }
          return statuses?.[0]?.startTime
        }, [selectedNodeId, statuses]),
        [searchParams] = useSearchParams(),
        provider = useMemo(() => providerProp !== undefined ? providerProp : searchParams.get("provider") || undefined, [providerProp, searchParams]),
        jobId = useMemo(() => searchParams.get("jobId") || undefined, [searchParams]),
        getQueryBuilder = useCallback(() => new Query.Builder(dispatch(getApiConfig())).withHeader("Target", provider, true), [dispatch, provider]),
        { searchFilesCall, getFileSizeCall } = filesDatalakeQueries.useOpenEditorBasedOnFile({ 
          getQueryBuilder,
          file: value,
          date,
          output
        }),
        onPreviewSubmitCallback = useCallback(val => onChange(val), [onChange]),
        preview = useCallback(() => {
          if(valueType !== DataScienceEnums.TASK_PARAM_VALUE_TYPE.DATALAKE_FILE && dynamic) {
            setOpen(true)
          } else {
            dispatch(commonDatalakeActions.openEditorBasedOnFile(value, { dynamic, searchFilesCall, getFileSizeCall, provider, taskId: selectedNodeId, jobId, onSubmitCallback: onPreviewSubmitCallback }))
          }
        }, [valueType, dynamic, dispatch, value, searchFilesCall, getFileSizeCall, provider, selectedNodeId, jobId, onPreviewSubmitCallback]),
        closeInfo = useCallback(() => setOpen(false), [])

  return (
    <WithTooltip
        data-place="top"
        short
        text="Preview"
    >
      <div 
          className="data-science__pipeline-creator__body__options__resolver__header__controls__control"
          onClick={preview}
      >
        <PreviewIcon
            color="blue-bright"
            height={16}
            width={16}
        />
        <When condition={open}>
          {() => (
            <InfoModal
                onClose={closeInfo}
                open={open}
                size="small"
                sizeWidth="small"
                title={name}
            >
              {value}
            </InfoModal>
          )}
        </When>
      </div>
    </WithTooltip>
  )
}

Preview.propTypes = {
  dynamic: PropTypes.bool,
  name: PropTypes.string,
  output: PropTypes.bool,
  provider: PropTypes.string,
  value: PropTypes.any.isRequired,
  valueType: PropTypes.string,
}

export default Preview;
